import { render } from "./VDropdown.vue?vue&type=template&id=98f2fe1a&ts=true"
import script from "./VDropdown.ts?vue&type=script&lang=ts"
export * from "./VDropdown.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__